<template>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title"><b>
            <!-- {{ id ? "Update" : "Add" }} -->
              Create Classroom</b></p>
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field label="Grade & Subjects *">
                <b-select placeholder="Grade & Subjects" v-model="classroom.grade_subject" expanded>
                    <option :value="grade._id" v-for="(grade) in fetchGradeSubjects" :key="grade._id" >{{ grade.grade.name }} - {{ grade.subject.name }}</option>
                </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field label="Section *">
                <b-select placeholder="Section" v-model="classroom.section" expanded>
                    <option :value="section._id" v-for="(section) in fetchSections" :key="section._id" >{{ section.name }}</option>
                </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field label="Remarks *">
              <b-input
                type="text"
                placeholder="Remarks"
                v-model="classroom.remarks"
                required
              ></b-input>
            </b-field>
          </div>
          <div class="column is-12">
            <b-button
              @click="proceed()"
              class="btn-center"
              type="is-primary"
              >
              <!-- {{ id ? "Update" : "Create" }}  -->
              Create Classroom</b-button
            >
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Close
        </button>
      </footer>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  export default {
    name: "set-user",
    components : {
    },
    props: {
      type:{
        type:String,
      }
    },
    data() {
      return {
        classroom:{
            grade_subject:"",
            section:"",
            remarks:"",
        },
      }
    },
    computed: {
      ...mapGetters(["getTeacherToken", 
      "fetchGradeSubjects",
      "fetchSections"
    //   "fetchPODetails"
    ]),
    },
    methods: {
      ...mapActions([
        "createClassroom",
        // "updatePO",
        "loadSections",
        "loadGradeSubjects"
    ]),
      proceed() {
        // if (this.id) {
        //   //For update
        //   this.updatePO({
        //     id: this.id,
        //     po: this.po,
        //     token: this.userToken,
        //   })
        //     .then(() => {
        //       this.$emit("over");
        //       this.$buefy.toast.open({
        //         message: "PO updated successfully",
        //         type: "is-success",
        //       });
        //     })
        //     .catch((err) => {
        //       this.$buefy.toast.open({
        //         message: err.response.data['msg'],
        //         type: "is-danger",
        //       });
        //     });
        // } else {
          //For new
          this.createClassroom({
            classroom: this.classroom,
            token: this.getTeacherToken,
          })
            .then(() => {
              this.$emit("over");
              this.$buefy.toast.open({
                message: "Classroom created successfully",
                type: "is-success",
              });
            })
            .catch((err) => {
              this.$buefy.toast.open({
                message: err.response.data['msg'],
                type: "is-danger",
              });
            });
        }
    //   },
    },
    watch:{
    //   fetchPODetails(new_val){
    //      for(let key in this.po){
    //           this.po[key]=new_val[key]
    //      }
    //   }
    },
    async created() {
        this.loadSections({token: this.getTeacherToken})
        this.loadGradeSubjects({token: this.getTeacherToken})
    //   if(this.id){
    //     this.loadPODetails({id:this.id,token:this.userToken})
    //   }
    },
  };
  </script>
  <style scoped>
  .button {
    flex-direction: row;
    width: 100%;
    background: #8919e7;
    color: #fff;
    gap: 1vw;
    cursor: pointer;
    position: relative;
    text-transform: capitalize;
    max-width: -webkit-fit-content;
    max-width: -moz-fit-content;
    max-width: fit-content;
    padding: 1.2vw 5vw;
    border-radius: 1.1vw;
    font-size: 1.2vw;
  }
  .button.outline {
    border: 0.063rem solid #8919e7;
    background: #fff;
    color: #000;
  }
  </style>